import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'
import EventBus from '../core/EventBus'
import { queryAll } from '../utils/dom'
import {EVENTS} from '../core/Events'
import Scroll from '../services/Scroll'

export default class Page extends Component {
    constructor(element, options) {
        super(element, options = {})
        this.otherVideosOnPage = []
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)

        EventBus.on(EVENTS.MODAL_OPEN, this.handleModalOpen)
        EventBus.on(EVENTS.MODAL_CLOSE, this.handleModalClose)
        Scroll.on('scroll', this.handleScroll)
    }

    handleScroll = ({y}) => {
        document.documentElement.classList.toggle('is-scrolled', y > 400)
    }

    handleModalOpen = () => {
        this.pausePageVideos()
    }

    handleModalClose = () => {
        this.resumePageVideos()
    }

    pausePageVideos() {
        this.otherVideosOnPage = queryAll('video')
                                    .filter(videoEl => !videoEl.closest('.Modal'))
                                    .map(videoEl => ({ element: videoEl, wasPlaying: !videoEl.paused, hasAutoplayLoop: videoEl.hasAttribute('autoplay') && videoEl.hasAttribute('loop')}))

        this.otherVideosOnPage.forEach(video => {
            if (!video.element.paused) {
                video.element.pause()
            }
        })
    }

    resumePageVideos() {
        this.otherVideosOnPage.forEach(video => {
            if (video.hasAutoplayLoop || video.wasPlaying) video.element.play()
        })
    }


    handleClick = (event) => {
        if (event.defaultPrevented) {
            return
        }
        let target = null

        target = event.target.closest("[data-trigger-click]")
        if (target) {
            this.processClickTrigger(target)
            return
        }

        target = event.target.closest("a")
        if (target) {
            this.processClickATag(target)
            return
        }
    }

    processClickATag(target) {
        const type = Object.prototype.toString.call(target.href)
        const href = type === "[object SVGAnimatedString]" ? target.href.baseVal : target.href
        if (document.location.href.split("#")[0] !== href.split("#")[0]) {
            return
        }

        const id = target.href.split("#")[1]
        if (!id) {
            return
        }

        const element = document.getElementById(id)
        if (!element) {
            return
        }

        event.preventDefault()

        let offset = target.dataset.offset ? target.dataset.offset : 0
        let mode = target.dataset.mode ? target.dataset.mode : "force-center"

        const toggleBlock = this.getToggleBlockComponent(element)
        if (toggleBlock) {
            const options = JSON.parse(target.dataset.toggleblockOptions || "{}")
            const action = options.action ?? "open"
            toggleBlock[action](options, {})
        } else {
            scrollToElement(element, { offset, mode })
        }
    }

    processClickTrigger(target) {
        const id = target.dataset.triggerClick?.replace("#", "")
        if (!id) {
            return
        }

        const link = document.getElementById(id)
        if (!link) {
            return
        }

        link.click()
    }

    getToggleBlockComponent(element) {
        const toggleBlockEl = element.closest('[data-component="ToggleBlock"]')

        if (toggleBlockEl) {
            const toggleBlock = Component.getFromElement(toggleBlockEl)
            return toggleBlock
        }

        return null
    }
}